import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrustedIframeSrcModule } from '../trusted-iframe-src.module';
import { VideoModalComponent } from './video-modal.component';

// The site's video pop-up, rendered once in AppComponent and opened through
// VideoModalService -- see video-modal.component.ts.
@NgModule({
  declarations: [VideoModalComponent],
  imports: [CommonModule, TrustedIframeSrcModule],
  exports: [VideoModalComponent],
})
export class VideoModalModule { }
